import { render, staticRenderFns } from "./FormNotification.vue?vue&type=template&id=7a0d6a28"
import script from "./FormNotification.vue?vue&type=script&lang=js"
export * from "./FormNotification.vue?vue&type=script&lang=js"
import style0 from "./FormNotification.vue?vue&type=style&index=0&id=7a0d6a28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports